module.exports = __webpack_public_path__ + "static/img/80.15384d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/80.png
// module id = cC+H
// module chunks = 1